import { render } from "./UsingTechnologies.vue?vue&type=template&id=543dc644"
import script from "./UsingTechnologies.vue?vue&type=script&lang=js"
export * from "./UsingTechnologies.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__